export const nextTab = {
    'problemType': '/modelPurpose',
    'modelPurpose': '/modelDetails/modelDetailsTab',
    'modelDetailsTab': '/hyperParameters',
    'runtimeCode': '/codetestinghardware'
};